"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _i18n = require("../../utils/i18n");

var _UIWrappedLink = _interopRequireDefault(require("../common/UIWrappedLink"));

var _helpers = require("../common/helpers");

var _moment = _interopRequireDefault(require("moment"));

var _FulfillerName = _interopRequireDefault(require("../common/FulfillerName"));

var _AccountName = _interopRequireDefault(require("../common/AccountName"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LatestInvoicesWidget =
/*#__PURE__*/
function (_Component) {
  _inherits(LatestInvoicesWidget, _Component);

  function LatestInvoicesWidget() {
    _classCallCheck(this, LatestInvoicesWidget);

    return _possibleConstructorReturn(this, _getPrototypeOf(LatestInvoicesWidget).apply(this, arguments));
  }

  _createClass(LatestInvoicesWidget, [{
    key: "renderInvoiceRow",
    value: function renderInvoiceRow(title, value) {
      return _react["default"].createElement("div", {
        className: 'riw-inv-row'
      }, _react["default"].createElement("div", {
        className: 'riw-inv-title'
      }, _react["default"].createElement("h6", null, title)), _react["default"].createElement("div", {
        className: 'riw-inv-value'
      }, value));
    }
  }, {
    key: "renderLinks",
    value: function renderLinks(c) {
      if (!this.props.showLinks) {
        return null;
      }

      var at = this.props.accessToken;
      var summaryLink = ((c.links || {}).summary || {}).href;
      var detailsLink = ((c.links || {}).details || {}).href;

      if (!summaryLink && !detailsLink) {
        return (0, _i18n.tt)(this.props, 'invoices:no_details');
      }

      return _react["default"].createElement(_react.Fragment, null, "(", _react["default"].createElement(_UIWrappedLink["default"], {
        t: this.props.t,
        title: 'PDF',
        href: summaryLink,
        isPdf: true,
        filename: "".concat(c.id, "_invoice_ref.pdf"),
        accessToken: at
      }), ",\xA0", _react["default"].createElement(_UIWrappedLink["default"], {
        t: this.props.t,
        title: 'CSV',
        href: detailsLink,
        filename: "".concat(c.id, "_invoice_items.csv"),
        accessToken: at
      }), ")");
    }
  }, {
    key: "renderInvoicePrice",
    value: function renderInvoicePrice(inv) {
      return _react["default"].createElement("strong", null, inv.currency, " ", inv.totalAggregation.amount.toFixed(2));
    }
  }, {
    key: "renderEntity",
    value: function renderEntity(id, type) {
      if (type === 'Fulfiller') {
        return _react["default"].createElement(_FulfillerName["default"], {
          accessToken: this.props.accessToken,
          fulfillerId: id
        });
      } else if (type === 'Account') {
        return _react["default"].createElement(_AccountName["default"], {
          accessToken: this.props.accessToken,
          accountId: id
        });
      }

      return id;
    }
  }, {
    key: "renderDate",
    value: function renderDate(date) {
      if (this.props.dateFormatFunc) {
        return this.props.dateFormatFunc(date);
      }

      return (0, _moment["default"])(date).format(this.props.dateFormat);
    }
  }, {
    key: "renderInvoice",
    value: function renderInvoice(inv, i, isLast) {
      return _react["default"].createElement("div", {
        className: 'riw-inv',
        key: i
      }, _react["default"].createElement("div", {
        className: 'riw-inv-cap'
      }, this.renderDate(inv.createdAt), this.props.showReference ? _react["default"].createElement(_react.Fragment, null, "\xA0-\xA0", _react["default"].createElement("strong", null, inv.id.toUpperCase())) : null, this.props.showLinks ? _react["default"].createElement("span", null, "\xA0-\xA0") : null, this.renderLinks(inv)), this.props.showSeller ? this.renderInvoiceRow((0, _i18n.tt)(this.props, 'field-seller-caption'), this.renderEntity(inv.sellerId, inv.sellerType)) : null, this.props.showBuyer ? this.renderInvoiceRow((0, _i18n.tt)(this.props, 'field-buyer-caption'), this.renderEntity(inv.buyerId, inv.buyerType)) : null, this.props.showAmount ? this.renderInvoiceRow((0, _i18n.tt)(this.props, 'field-amount-caption'), this.renderInvoicePrice(inv)) : null);
    }
  }, {
    key: "renderInvoices",
    value: function renderInvoices() {
      var _this = this;

      if (!this.props.invoices) {
        return null;
      }

      var allCount = this.props.invoices.length;

      if (allCount === 0) {
        var _content = _react["default"].createElement("div", {
          className: 'riw-no-invoices'
        }, (0, _i18n.tt)(this.props, 'latestInvoices:no-invoices'));

        if (!this.props.wrapInCardWithTitle) {
          return _content;
        }

        return (0, _helpers.renderCard)(_react["default"].createElement("span", {
          className: 'riw-card-header'
        }, (0, _i18n.tt)(this.props, 'latestInvoices:widget-title')), _content);
      }

      var items = this.props.invoices.slice(0, this.props.maxInvoices);

      var content = _react["default"].createElement(_react.Fragment, null, items.map(function (inv, i) {
        return _this.renderInvoice(inv, i, i === items.length - 1);
      }), _react["default"].createElement("div", {
        className: 'riw-view-all-wrapper'
      }, _react["default"].createElement("a", {
        href: "https://manage.invoices.cimpress.io/identity/".concat(this.props.identity.id, "/").concat(this.props.identity.type, "/invoices"),
        target: "_blank",
        rel: "noopener noreferrer"
      }, (0, _i18n.tt)(this.props, 'latestInvoices:view-all'))));

      if (!this.props.wrapInCardWithTitle) {
        return content;
      }

      return (0, _helpers.renderCard)(_react["default"].createElement("span", {
        className: 'riw-card-header'
      }, (0, _i18n.tt)(this.props, 'latestInvoices:widget-title'), " (", (0, _i18n.tt)(this.props, 'total'), ' ', allCount, ")"), content);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.wrapInCardWithTitle) {
        return this.renderInvoices();
      }

      return _react["default"].createElement("div", {
        className: 'riw-latest-invoices'
      }, _react["default"].createElement("div", {
        id: 'cas-saving-overlay',
        className: "cas-saving-overlay-hidden"
      }, _react["default"].createElement("img", {
        style: {
          position: 'fixed',
          top: 'calc(50% - 38px)',
          left: 'calc(50% - 38px)'
        },
        src: "https://static.ux.cimpress.io/mcp-ux-css/1.4/development/1.4.7/assets/spinner.svg",
        alt: "loading"
      })), this.renderInvoices());
    }
  }]);

  return LatestInvoicesWidget;
}(_react.Component);

LatestInvoicesWidget.propTypes = {
  locale: _propTypes["default"].string,
  accessToken: _propTypes["default"].string.isRequired,
  identity: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired
  }),
  maxInvoices: _propTypes["default"].number,
  invoices: _propTypes["default"].array,
  dateFormat: _propTypes["default"].string,
  dateFormatFunc: _propTypes["default"].func,
  showAmount: _propTypes["default"].bool,
  showLinks: _propTypes["default"].bool,
  showBuyer: _propTypes["default"].bool,
  showSeller: _propTypes["default"].bool,
  showReference: _propTypes["default"].bool,
  wrapInCardWithTitle: _propTypes["default"].bool,
  t: _propTypes["default"].func,
  // comes from withTranslation
  i18n: _propTypes["default"].any // comes from withTranslation

};
LatestInvoicesWidget.defaultProps = {
  locale: 'en',
  maxInvoices: 3,
  invoices: null,
  dateFormat: 'YYYY-MMM-DD',
  showAmount: true,
  showLinks: true,
  showBuyer: true,
  showSeller: true,
  showReference: true,
  wrapInCardWithTitle: true
};

var _default = (0, _reactI18next.withTranslation)()(LatestInvoicesWidget);

exports["default"] = _default;